module.exports = __webpack_public_path__ + "img/Forschung.f00adc79.jpg";